import { useTranslation } from 'react-i18next';
import { ColorField } from './ColorField';
import type { IBuilderCardProps } from './IBuilderCardProps';

/**
 * «Кольори значень» конструктора (прототип v4 bHasEnums): поля вибору зі значеннями (статус, пріоритет, серйозність…) — по картці на поле;
 * власні поля простору кольорів не мають. Без полів вибору картки немає.
 */
export function ColorsCard({ rt, editor, strings }: IBuilderCardProps) {
  const { t } = useTranslation();
  const fields = rt.fields.filter((f) => !f.hidden && f.storage !== 'ext' && f.type === 'select' && (f.key === 'status' ? rt.statuses.list.length > 0 : (f.options ?? []).length > 0));
  if (!fields.length) return null;
  return (
    <section className="rb-card" aria-label={t('rtBuilder.colours')}>
      <div className="rb-card__titles">
        <div className="rb-card__title">{t('rtBuilder.colours')}</div>
        <div className="rb-card__sub">{t('rtBuilder.coloursSub')}</div>
      </div>
      <div className="rb-enums">
        {fields.map((f) => <ColorField key={f.key} rt={rt} field={f} patch={editor.patch} strings={strings} canEdit={editor.canEdit} onEdit={editor.apply} />)}
      </div>
    </section>
  );
}
